var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sv-preloader"},[_c('div',{staticClass:"sv-preloader__text"},[_vm._v(_vm._s(_vm.preloaderText))]),_vm._v(" "),_c('div',{staticClass:"sv-preloader__line",style:(`width: ${_vm.pct}%`)}),_vm._v(" "),_c('div',{staticClass:"sv-preloader__header"},[_c('header-logo',{attrs:{"locale":_vm.locale}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }